var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPointerClick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0677 28.0099L28.2814 31.796L28.1126 31.9822L22.2472 26.1167L19.1709 31.796L11.7168 11.5635L31.2394 19.1359L26.2701 22.2122L32.0677 28.0099Z",
    stroke: "#FA6138",
    strokeWidth: 3.33333,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.32662 18.9561L5.45527 21.7074M6.35924 13.4161H1.99707M7.82009 7.81242C7.06002 7.09815 4.74695 4.7498 4.74695 4.7498M13.4133 7.39032V1.83325M18.7668 8.3471L21.663 5.41644",
    stroke: "#FA6138",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointerClick);
export default __webpack_public_path__ + "static/media/pointer-click.1a8ec1d95203809348220b57c430e638.svg";
export { ForwardRef as ReactComponent };